var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('el-button',{attrs:{"type":"danger","icon":"el-icon-folder-delete"},on:{"click":function($event){return _vm.handleTruncateConfirm()}}},[_vm._v("Truncate")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }